import { useDisclosure } from '@chakra-ui/react';
import { RouteElement, withRouteId } from '@melio/ar-domain';
import { forwardRef } from '@melio/platform-utils';
import { Route, Routes } from 'react-router-dom';

import {
  GuestPaymentRequestDetailsActivity as _GuestPaymentRequestDetailsActivity,
  InvoiceDrawerActivity as _InvoiceDrawerActivity,
} from '../activities';
import { GuestPaymentRouterFlow } from './GuestPayment.router.flow';

const GuestPaymentRequestDetailsActivity = withRouteId(_GuestPaymentRequestDetailsActivity, 'paymentRequestLink');
const InvoiceDrawerActivity = withRouteId(_InvoiceDrawerActivity, 'paymentRequestLink');

export const NewGuestPaymentWithAuthFlow = forwardRef((_props, ref) => {
  const { isOpen: isDrawerOpened, onOpen: onDrawerOpen, onClose: onDrawerClose } = useDisclosure();

  return (
    <Routes>
      <Route
        path="pay/r/:id/*"
        element={
          <>
            <GuestPaymentRequestDetailsActivity onDone={() => null} onViewInvoice={onDrawerOpen} ref={ref} />
            <InvoiceDrawerActivity
              isOpened={isDrawerOpened}
              onDownloadInvoice={(fileUrl) => {
                window.location.href = fileUrl;
              }}
              onClose={onDrawerClose}
              ref={ref}
            />
          </>
        }
      />
      <Route
        path="pay-new/r/:id/*"
        element={
          <>
            <RouteElement
              component={GuestPaymentRouterFlow}
              pathToProps={{ id: 'paymentRequestLink' }}
              onViewInvoice={onDrawerOpen}
              ref={ref}
            />
            <InvoiceDrawerActivity
              isOpened={isDrawerOpened}
              onDownloadInvoice={(fileUrl) => {
                window.location.href = fileUrl;
              }}
              onClose={onDrawerClose}
              ref={ref}
            />
          </>
        }
      />
    </Routes>
  );
});
NewGuestPaymentWithAuthFlow.displayName = 'NewGuestPaymentWithAuthFlow';
